import { useState, useCallback } from 'react';
import { SubscriptionService } from '@/services/billing/SubscriptionService';

export const useBillingPortal = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const openBillingPortal = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const url = await SubscriptionService.getBillingPortalUrl({
        returnUrl: `${window.location.href}?from=billing`,
      });

      window.open(url, "_blank");
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : "An unexpected error occurred";
      setError(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  return {
    openBillingPortal,
    loading,
    error,
    clearError,
  };
};
